export default __webpack_public_path__ + "static/media/June2012.6cd1e941.png";